import type { ReactNode } from 'react';

import { useUserEnvironment } from '#/contexts/UserEnvironmentContext';

type Props = {
  children: ReactNode;
  loading: ReactNode;
  loggedOut: ReactNode;
};

export function LoggedInSwitcher({ children, loading, loggedOut }: Props) {
  const { user, isUserLoaded } = useUserEnvironment();

  let value;

  if (!isUserLoaded) {
    value = loading;
  } else if (!user) {
    value = loggedOut;
  } else {
    value = children;
  }

  return value;
}
